import { Account, AccountState } from '../../model/account/account';
import { AccountTypeId } from '../../model/account/accountTypeId';
import { Role } from '../../model/account/role';
import { ActiveState } from '../../model/active/ActiveState';
import { AdminState } from '../../model/admin/adminState';
import { ComplianceState } from '../../model/admin/complianceState';
import { SettingsState } from '../../model/admin/settingsState';
import { DailyMetricsState } from '../../model/dailyMetricsState';
import { DailyParametersState } from '../../model/DailyParametersState';
import { ErrorState } from '../../model/error/ErrorState';
import { PassiveParametersState } from '../../model/passiveParametersState';
import { PatientsState } from '../../model/patient/PatientsState';
import { ReportingState } from '../../model/reporting/reportingState';

export interface SystemState {
  account: AccountState;
  patients: PatientsState;
  dailyMetrics: DailyMetricsState;
  dailyParameters: DailyParametersState;
  passiveParameters: PassiveParametersState;
  active: ActiveState;
  admin: AdminState;
  compliance: ComplianceState;
  settings: {
    environment: SettingsState;
    user: SettingsState;
  };
  reporting: ReportingState;
  error: ErrorState;
}

const accountJson = localStorage.getItem('account');
const parsedAccount = accountJson !== null ? JSON.parse(accountJson) : null;
const account: Account =
  parsedAccount !== null
    ? { ...parsedAccount, role: Number(parsedAccount.role) }
    : {
        accountGuid: '',
        password: '',
        accountType: {
          accountTypeId: AccountTypeId.Account,
          description: '',
        },
        created: '',
        email: '',
        firstName: '',
        lastName: '',
        isTwoFactorAuthenticationEnabled: false,
        isTwoFactorAuthenticationSetupCompleted: false,
        isVerified: false,
        jwtToken: '',
        role: Role.User,
        //bug in backend - the getAll for account management is not populating "accountType" above, but is working with accountTypeId below. When this is fixed, accountTypeId should be deleted
        accountTypeId: 0,
        rememberMe: false,
        isTwoFactorAuthenticationPassed: false,
      };

export const initialState: SystemState = {
  account: {
    account: account,
    error: null,
    isLoading: false,
  },
  patients: {
    patients: [],
    pendingPatients: [],
    selectedPatient: null,
    patientDetailError: null,
    patientTests: [],
    selectedTest: {
      dateTime: '',
      detail: null,
      tableData: null,
      isLoading: false,
    },
    isLoading: false,
  },
  dailyMetrics: {
    dates: [],
    selectedDate: null,
    selectedDailyMetrics: null,
    isLoading: false,
  },
  dailyParameters: {
    dates: [],
    selectedDailyParameterData: [],
    averageWalkingSpeedData: [],
    temperatureData: [],
    passiveParameterDataMap: {},
    passiveParameterData: {},
  },
  passiveParameters: {
    selectedAlertDetails: [],
    isLoading: false,
  },
  active: {
    overview: null,
    dates: [],
    selectedDate: null,
    selectedActiveTestData: [],
  },
  admin: {
    hcpAccounts: [],
    patientAccounts: [],
    invitationCodes: [],
  },
  compliance: {
    overview: {
      currentPeriod: null,
      previousPeriod: null,
    },
    periods: [],
  },
  settings: {
    environment: {
      DailyMetricsVisibility: {
        pressureDistribution: false,
        temperatureDistribution: false,
        dailyParameters: false,
        activityTracker: false,
      },
      DailyParametersVisibility: {
        totalDistance: false,
        averageWalkingSpeed: false,
        averageAsymmetry: false,
        averageCadence: false,
        totalSteps: false,
        averageVariability: false,
        averageCycleDuration: false,
        averageSwingSpeed: false,
        averageStrideLength: false,
        averageSwing: false,
        Temperature: false,
      },
      OtherVisibility: {
        latest10MWT: false,
        latestTUG: false,
        latestCustom: false,
        latestCompliance: false,
      },
    },
    user: {
      DailyMetricsVisibility: {
        pressureDistribution: false,
        temperatureDistribution: false,
        dailyParameters: false,
        activityTracker: false,
      },
      DailyParametersVisibility: {
        totalDistance: false,
        averageWalkingSpeed: false,
        averageAsymmetry: false,
        averageCadence: false,
        totalSteps: false,
        averageVariability: false,
        averageCycleDuration: false,
        averageSwingSpeed: false,
        averageStrideLength: false,
        averageSwing: false,
        Temperature: false,
      },
      OtherVisibility: {
        latest10MWT: false,
        latestTUG: false,
        latestCustom: false,
        latestCompliance: false,
      },
    },
  },
  reporting: {
    latestSystemAlerts: [],
  },
  error: {
    showDialog: false,
    error: '',
  },
};
